import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import WhatsAppButton from "./components/layout/WhatsAppButton";

// Pages
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import RentalPage from "./pages/RentalPage";
import CompanyPage from "./pages/CompanyPage";
import DifferentialsPage from "./pages/DifferentialsPage";
import ContactPage from "./pages/ContactPage";
import AccessoriesPage from "./pages/AccessoriesPage";

// Layout wrapper component
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/produtos" element={<ProductsPage />} />
            <Route path="/produtos/:id" element={<ProductDetailPage />} />
            <Route path="/locacao" element={<RentalPage />} />
            <Route path="/empresa" element={<CompanyPage />} />
            <Route path="/diferenciais" element={<DifferentialsPage />} />
            <Route path="/contato" element={<ContactPage />} />
            <Route path="/pneus-acessorios" element={<AccessoriesPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;